type MetaWithEnv = ImportMeta & {
  env?: {
    VITE_API_BASE?: string;
    DEV?: boolean;
    [key: string]: string | undefined;
  };
};

const metaEnv = (import.meta as MetaWithEnv).env || {};

function resolveApiBase() {
  const raw = String(metaEnv.VITE_API_BASE || "").trim();
  const runtimeOrigin =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin.replace(/\/+$/, "")
      : "";
  if (!raw) return runtimeOrigin;

  if (metaEnv.DEV && runtimeOrigin) {
    try {
      const envOrigin = new URL(raw, runtimeOrigin).origin;
      if (envOrigin !== runtimeOrigin) {
        // Prefer same-origin in dev so the Vite proxy can handle cross-origin APIs.
        return runtimeOrigin;
      }
    } catch {
      // ignore invalid env URL
    }
  }

  return raw.replace(/\/+$/, "");
}

export const API_BASE = resolveApiBase();
